module.exports = __webpack_public_path__ + "static/media/logo_interdoc.ed053e19.png";